// /frontend/src/api/schoolSettings.js
import api from '@/services/api';

export const schoolSettingsApi = {
  getCurrent() {
    return api.get('/school-settings');
  },
  update(payload) {
    // Erwartet ein Objekt mit Feldern im snake_case (siehe Dialog)
    return api.put('/school-settings', payload);
  }
};
